// Google Business Profile links for each location. "listing" opens the Maps
// listing with its reviews; "write" opens Google's write-a-review form.
// The site also redirects /review and /review-gaylord to the "write" links
// (public/.htaccess), which is what the printed QR cards point to.
export const reviewLinks = {
  niles: {
    listing: 'https://maps.app.goo.gl/zfpPeS4MScBWaTry7',
    write: 'https://search.google.com/local/writereview?placeid=ChIJvTo1q6YrEYgRR3q58dq2Y9Y'
  },
  gaylord: {
    listing: 'https://maps.google.com/?cid=614490981046181289',
    write: 'https://search.google.com/local/writereview?placeid=ChIJuSGJ1IE3maoRqV3wokochwg'
  }
};
